import * as Icon from "@phosphor-icons/react/dist/ssr";

const BannerSpeacial = () => {
  return (
    <div className='fx-reveal overflow-hidden my-5'>
        <div className='flex max-sm:flex-col justify-center w-full relative'>
            <div className='bg-pink p-6 w-3/12 max-sm:w-full flex justify-center items-center text-center circle-rotate-spe'>
                <p className='text-greenprimary font-bold text-2xl z-10'>Discount</p>
            </div>
            <div className='bg-greenprimary p-6 max-sm:w-full max-sm:flex-col max-sm:gap-3 w-9/12 text-center relative flex justify-around items-center'>
                <p className='text-pink font-bold 2xl:text-2xl xl:text-2xl lg:text-xl w-2/4 max-sm:w-10/12 m-auto z-10 relative'>Jusqu&apos;à 70 % de réduction sur tous les articles </p>
                <button
                  className='flex items-center bg-pink p-3 rounded-md gap-4 text-white px-7 cursor-pointer'
                  onClick={()=>{
                    window.location.href = "/shop"
                  }}
                >
                  Découvrir <Icon.ArrowRight />
                </button>
            </div>
        </div>
    </div>
  )
}

export default BannerSpeacial